module.exports = __webpack_public_path__ + "img/inhalt_pic_mobile.cdc04dc8.jpg";